import React from 'react';

import VerticalAds from '../../components/Adds/VerticalAds';
import FeaturedSection from '../../components/anchorComponents/FeaturedSection';
import LiveBanner from '../../components/anchorComponents/LiveBanner';
import NNLiveSchedule from '../../components/anchorComponents/NNLiveSchedule';
import SimpleVideoPlayer from '../../components/blogComponents/SimpleVideoPlayer';
import ContextualJoinOverlay from '../../components/generalComponents/ContextualJoinOverlay/ContextualJoinOverlay';
import TulumRealityShow from './TulumRealityShow/TulumRealityShow';

const TULUM_REALITY_SHOW = 'TULUM_REALITY_SHOW';

function NakedNewsLivePage(props) {
  const {
    anchor,
    anchorsList,
    anchorId,
    anchorVideoUrl,
    chatService,
    chatServiceTem,
    extractIdFromSlug,
    guestUser,
    history,
    isBanned,
    toggleContextualJoinOverlay,
    slug,
    user,
    onNetworkError,
    galleriesAndVideosCount,
    anchorPortalCampaign,
    showOverlay,
    pageItemsShown,
    setBanStatus,
    setItemsCount,
    location,
    fetchStreamDetails,
    isSpotlighing,
    spotlighedAnchorNickname,
    spotlighedAnchorUsername,
    livePageAdData,
    nakedNewsLivePromoClip,
    nakedNewsLivePromoImage,
    nakedNewsLiveAnchorData,
    setNakedNewsLivePageAd,
    setNakedNewsLivePromoUrl,
  } = props;

  const isTulumRealityShowAvailable = user?.temptedFeatures?.includes(TULUM_REALITY_SHOW);

  return (
    <>
      {isTulumRealityShowAvailable ? (
        <TulumRealityShow
          anchor={anchor}
          anchorId={anchorId}
          anchorVideoUrl={anchorVideoUrl}
          chatService={chatService}
          chatServiceTempted={chatServiceTem}
          extractIdFromSlug={extractIdFromSlug}
          fetchStreamDetails={fetchStreamDetails}
          galleriesAndVideosCount={galleriesAndVideosCount}
          guestUser={guestUser}
          history={history}
          isLivePage={true}
          isSpotlighing={isSpotlighing}
          openContextualOverlay={toggleContextualJoinOverlay}
          slug={slug}
          spotlighedAnchorNickname={spotlighedAnchorNickname}
          spotlighedAnchorUsername={spotlighedAnchorUsername}
          user={user}
          onNetworkError={onNetworkError}
        />
      ) : (
        <LiveBanner
          anchor={anchor}
          anchorId={anchorId}
          anchorVideoUrl={anchorVideoUrl}
          chatService={chatService}
          chatServiceTempted={chatServiceTem}
          extractIdFromSlug={extractIdFromSlug}
          fetchStreamDetails={fetchStreamDetails}
          galleriesAndVideosCount={galleriesAndVideosCount}
          guestUser={guestUser}
          history={history}
          isLivePage={true}
          isSpotlighing={isSpotlighing}
          openContextualOverlay={toggleContextualJoinOverlay}
          slug={slug}
          spotlighedAnchorNickname={spotlighedAnchorNickname}
          spotlighedAnchorUsername={spotlighedAnchorUsername}
          user={user}
          nakedNewsLiveAnchorData={nakedNewsLiveAnchorData}
          onNetworkError={onNetworkError}
        />
      )}

      <div className="bio-ad-container live-page">

        <div className="col-md-6 com-sm-12 col-xs-12 anchor-fan-zone-free-video live">
          <VerticalAds adData={livePageAdData} />
          <SimpleVideoPlayer
            clip={{ videoUrl: nakedNewsLivePromoClip, imageUrl: nakedNewsLivePromoImage }}
            fanZoneFreeVideo={true}
            user={user}
          />
        </div>
        <NNLiveSchedule setNakedNewsLivePageAd={setNakedNewsLivePageAd} />
      </div>
      <ContextualJoinOverlay
        anchorId={anchorId}
        anchorPortalCampaign={anchorPortalCampaign}
        anchorShortUrl={slug}
        closeContextualOverlay={toggleContextualJoinOverlay}
        history={history}
        setNakedNewsLivePromoUrl={setNakedNewsLivePromoUrl}
        showOverlay={showOverlay}
        user={user}
      />
      <FeaturedSection
        anchorName={anchor.name}
        anchorShortUrl={slug}
        anchors={anchorsList}
        extractIdFromSlug={extractIdFromSlug}
        galleriesAndVideosCount={galleriesAndVideosCount}
        id={anchorId}
        location={location}
        pageItemsShown={pageItemsShown}
        setBanStatus={setBanStatus}
        setItemsCount={setItemsCount}
        showClipStore={anchor.clipStoreItemsCount > 0}
        user={user}
      />
    </>
  );
}

export default NakedNewsLivePage;
